/** The asset index route, not one of its nested reporting/settings pages. */
export const isAccountOverviewDashboardPath = (pathname: string): boolean => {
	const parts = pathname.split('/').filter(Boolean)
	return parts.length === 4 && parts[0] === 'workspace' && parts[2] === 'asset'
}
